import { createSelector } from 'reselect';

export const getOffers = ({ offers } = {}) => offers;

export const getOffersRelatedNavigation = createSelector(
  [getOffers],
  ({ relatedNavigation } = {}) => relatedNavigation,
);

export const getOfferSubCategories = createSelector(
  [getOffers],
  ({ subCategories } = {}) => subCategories,
);
